export enum FilterType {
  PenRange = "pen-range",
}
